export default function BlurbDate({ date, endDate, className = '' }) {
  if (!date) return null;

  // Attempt to parse the date string securely.
  const defaultDate = new Date(date);

  if (isNaN(defaultDate.getTime())) return null;

  const day = defaultDate.getDate();
  const month = defaultDate.toLocaleString('no-NO', { month: 'short' }).toUpperCase();

  let endDay, endMonth, startYear, endYear;
  if (endDate && endDate !== date) {
    const parsedEndDate = new Date(endDate);
    if (!isNaN(parsedEndDate.getTime())) {
      endDay = parsedEndDate.getDate();
      endMonth = parsedEndDate.toLocaleString('no-NO', { month: 'short' }).toUpperCase();
      if (parsedEndDate.getFullYear() !== defaultDate.getFullYear()) {
        startYear = defaultDate.getFullYear();
        endYear = parsedEndDate.getFullYear();
      }
    }
  }

  return (
    <div className={`Blurb__date ${endDay ? 'Blurb__date--range' : ''} ${className}`.trim()}>
      {!endDay ? (
        <>
          <span className="Blurb__date-day">{day}</span>
          <span className="Blurb__date-month">{month}</span>
        </>
      ) : (
        <>
          <div className="Blurb__date-single">
            <span className="Blurb__date-day">{day}</span>
            <span className="Blurb__date-month">{month}</span>
            {startYear && <span className="Blurb__date-year">{startYear}</span>}
          </div>
          <span className="Blurb__date-separator">-</span>
          <div className="Blurb__date-single">
            <span className="Blurb__date-day">{endDay}</span>
            <span className="Blurb__date-month">{endMonth}</span>
            {endYear && <span className="Blurb__date-year">{endYear}</span>}
          </div>
        </>
      )}
    </div>
  );
}
